import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class CookieHeightChangeService {
  private cookieHeightChanged: BehaviorSubject<number> = new BehaviorSubject(0);
  private openCloseCookieChanged: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public emitter: Observable<number> = this.cookieHeightChanged.asObservable();
  public openCloseCookie: Observable<boolean> = this.openCloseCookieChanged.asObservable();

  public setCookieHeight(height: number): void {
    this.cookieHeightChanged.next(height);
  }

  public openCookie(): void {
    this.openCloseCookieChanged.next(true);
  }

  public closeCookie(): void {
    this.openCloseCookieChanged.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/cookie/cookie-height-change.service.ts